export function usesSharedCustomerDetails(sport, isAdmin = false) {
  return String(sport || "").trim().toUpperCase() === "NBA" || !isAdmin;
}
